import { Space, Upload, Button, Row } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import galleryService from 'services/gallery';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const ImageGallery = ({
  fileList = [], // Files selected for upload (local state in MediaUpload)
  setFileList, // Setter for local selection
  type,
  form,
  multiple,
  loadingBtn,
  setLoadingBtn,
  handleClose,
  imageList, // Existing images from parent form
  setImageList, // Setter for existing images
}) => {
  const { t } = useTranslation();

  const createImage = (file) => {
    return {
      uid: file.title,
      name: file.title,
      status: 'done',
      url: file.title,
      created: true,
    };
  };

  const handleSave = () => {
    if (!fileList || fileList.length === 0) return;

    setLoadingBtn(true);
    const formData = new FormData();
    formData.append('type', type);
    fileList.forEach((item, index) => {
      if (item?.originFileObj) {
        formData.append(`images[${index}]`, item.originFileObj);
      }
    });

    galleryService
      .storeMany(formData)
      .then(({ data }) => {
        const images =
          data?.title?.map((item) => createImage({ title: item })) || [];

        // Update parent state if setters are provided
        if (setImageList) {
          const nextImageList = Array.isArray(imageList)
            ? [...imageList, ...images]
            : [...images];
          setImageList(nextImageList);

          if (form) {
            form.setFieldsValue({
              images: nextImageList,
            });
          }
        }
        handleClose();
      })
      .catch((err) => {
        toast.error(t('error.uploading.images'));
        console.error(err);
      })
      .finally(() => setLoadingBtn(false));
  };

  const handleChange = ({ fileList: newFiles }) => {
    setFileList(newFiles);
  };

  const handleRemove = (file) => {
    setFileList((prev) =>
      Array.isArray(prev) ? prev.filter((item) => item.uid !== file.uid) : [],
    );
  };

  const uploadButton = (
    <div className='upload-button-wrapper'>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{t('upload')}</div>
    </div>
  );

  return (
    <div
      className='image-gallery-container'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1, minHeight: '300px', overflowY: 'auto' }}>
        <Upload
          listType='picture-card'
          accept='.png,.jpg,.jpeg,.webp,.avif,jfif'
          onChange={handleChange}
          className='antdImgUpload'
          showUploadList={true} // Changed to true to show Ant Design's built-in preview/status
          fileList={fileList}
          customRequest={({ onSuccess }) => {
            setTimeout(() => onSuccess('ok'), 0);
          }}
          disabled={!multiple && fileList.length > 0}
          multiple={multiple}
        >
          {(multiple || fileList.length === 0) && uploadButton}
        </Upload>
      </div>

      <Space
        className='mt-4 w-100 justify-content-end'
        style={{ padding: '10px 0', borderTop: '1px solid #f0f0f0' }}
      >
        <Button
          type='primary'
          onClick={handleSave}
          loading={loadingBtn}
          disabled={!fileList?.length}
        >
          {t('save')}
        </Button>
        <Button onClick={handleClose}>{t('cancel')}</Button>
      </Space>
    </div>
  );
};

export default ImageGallery;
